var tableStyler = {}

tableStyler.style = function(content) {
    this.styleTableHeaders(content)
    this.styleTableRows(content)
}

tableStyler.styleTableHeaders = function(content) {
    $(content).find('table').each(function () {
        var $table = $(this)
        // $table.find('thead').each(function () { $table.attr('data-tableheadertype', ( $(this).find('th[colspan][colspan!=1]').length > 0 ) ? 'complex' : 'simple') })
        $table.attr('data-tableheadertype', ( ($table.find('thead th[colspan][colspan!=1]').length > 0) || $table.find('thead tr').length > 2) ? 'complex' : 'simple')
    })
}

tableStyler.styleTableRows = function(content) {
    var classes = ['odd', 'even']
    var classesCount = classes.length
    $(content).find('table').each(function () {
        var currentRowIndex = 1
        var $rows = $(this).find('tbody tr')
        if ( $rows.length > 0 ) {
            var rowSpanList = []
            var $cells = $($rows[0]).find('td')
            for ( var i = 0; i < $cells.length; i++ ) {
                var $cell = $($cells[i])
                var colspan = ~~$cell.attr('colspan') || 1
                for ( var j = 0; j < colspan; j++) {
                    rowSpanList.push(0)
                }
            }
            for ( var i = 0; i < $rows.length; i++) {
                var $row = $($rows[i])
                var $cells = $row.find('td')
                for (var j = 0; j < $cells.length; j++ ) {
                    var $cell = $($cells[j])
                    var colspan = ~~$cell.attr('colspan') || 1
                    var rowspan = ~~$cell.attr('rowspan') || 1
                    for ( var k = 0; k < colspan; k++) {
                        rowSpanList[rowSpanList.findIndex((element) => element == 0)] += rowspan
                    }
                }
                $row.attr('data-rowalternate', classes[currentRowIndex % classesCount])
                rowSpanList = rowSpanList.map(function (element) { return --element })
                if ( rowSpanList.reduce((partialSum, a) => partialSum + a, 0) < 1 ) {
                    currentRowIndex++
                }
            }
        }
    })
}
// tableStyler.style()

